<div
  class="layout-sidebar"
  [ngClass]="containerClass()"
  data-testid="sidebar"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <div class="sidebar-header h-[3.5rem] py-2 px-4">
    <a class="logo w-auto" routerLink="/app">
      <div id="logolink" class="cursor-pointer mr-auto flex justify-start items-center gap-2">
        <app-convivia-logo size="1.5rem" />
        <p class="text-xl font-montserrat font-semibold leading-6 text-center dark:text-green-500">Convivia</p>
      </div>
    </a>
    @if (isReveal()) {
      <button class="sidebar-anchor" type="button" aria-label="Anchor menu" (click)="anchor()"></button>
    }
  </div>
  <div #menuContainer class="menu-container overflow-auto flex-1">
    <div app-menu></div>
  </div>
  @if (!isMobile()) {
    <div app-topbar></div>
  }
</div>
<div class="layout-mask animate-fadein"></div>
